import {
  refFarmViewFunction,
  refFiViewFunction,
  refFarmBoostViewFunction,
  refSwapV3ViewFunction,
  refSwapV3OldVersionViewFunction,
  lockerViewFunction,
} from './near';

export const ACCOUNT_MIN_STORAGE_AMOUNT = '0.005';

interface AccountStorageView {
  total: string;
  available: string;
}

export const currentStorageBalance = (
  accountId: string
): Promise<AccountStorageView> => {
  return refFiViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};

export const currentStorageBalanceOfFarm = (
  accountId: string
): Promise<AccountStorageView> => {
  return refFarmViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};

export const currentStorageBalanceOfFarm_boost = (
  accountId: string
): Promise<AccountStorageView> => {
  return refFarmBoostViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};

export const currentStorageBalanceOfV3 = (
  accountId: string
): Promise<AccountStorageView> => {
  return refSwapV3ViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};
export const currentStorageBalanceOfV3_old_version = (
  accountId: string
): Promise<AccountStorageView> => {
  return refSwapV3OldVersionViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};

export const currentStorageBalanceOfLocker = (
  accountId: string
): Promise<AccountStorageView> => {
  return lockerViewFunction({
    methodName: 'storage_balance_of',
    args: { account_id: accountId },
  });
};
